import React, { useEffect, useState, useRef, useContext } from 'react';
import { Button, Select, DatePicker, Table } from 'antd';
import moment from 'moment';
import http from '../../../Http';
import utils from '../../../utils';
import config from '../../../Config';
import 'moment/locale/zh-cn';
import zh_CN from 'antd/lib/date-picker/locale/zh_CN';
import en_US from 'antd/lib/date-picker/locale/en_US';
import { useTranslation } from 'react-i18next';
import { red } from '@material-ui/core/colors';

function getTableScroll() {
    var th = document.getElementsByClassName("ant-table-thead")[0];
    let tHeaderBottom = 0
    if (th) {
        tHeaderBottom = th.getBoundingClientRect().top
    }
    let height = `calc(100vh - ${tHeaderBottom + 100}px)`
    return height
}

function DataHistoryUhomeThreePhase(props) {
    const { t, i18n } = useTranslation();
    const { Timezone, inverterSelectOptions, SN, model, protocol, handleSelectSN } = props
    const setTip = useContext(utils.tipContext)

    const [dataHistoryDate, setDataHistoryDate] = useState(moment().format('YYYY-MM-DD')) //时间
    const [aWeekAgoDate, setAWeekAgoDate] = useState(moment().subtract(7, 'days').format('YYYY-MM-DD'))  //一周前的日期, 导出用

    const [pageNo, setPageNo] = useState(0)
    const [pageSize, setPageSize] = useState(100)
    const [rows, setRows] = useState([])
    const [rowTotal, setRowTotal] = useState(0)
    const [loading, setLoading] = useState(false)

    const refDownloader1 = useRef(null)
    const refDownloader2 = useRef(null)

    const [scrollY, setScrollY] = useState("")

    useEffect(() => {
        setScrollY(getTableScroll())
    }, [])

    //取历史数据
    useEffect(() => {
        if (!SN) return;

        let active = true;

        (async () => {
            setLoading(true);

            let resp = await http.post("integrated-inverter/uhome-threephase/history/list", {
                PageNo: pageNo,
                PageSize: pageSize,
                SerialNumber: SN,
                STime: moment(dataHistoryDate).format("YYYY-MM-DD"),
                ETime: moment(dataHistoryDate).add(1, "days").format("YYYY-MM-DD"),
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load data error") });
                setRowTotal(0)
                setRows([])
                return;
            }
            setRowTotal(resp.data.RowTotal);
            setRows(resp.data.Rows);
            setLoading(false);
        })();

        return () => {
            active = false;
        };
    }, [pageNo, pageSize, SN, dataHistoryDate, t]);

    const handleExport = () => {
        if (!refDownloader1.current) {
            return;
        }
        refDownloader1.current.click()
    }

    const handleExportWeek = () => {
        if (!refDownloader2.current) {
            return;
        }
        refDownloader2.current.click()
    }

    //根据三相逆变器显示相应字段
    const DefaultColumns = [
        {
            title: "",
            width: 40,
            fixed: 'left',
            render: (v, r, idx) => {
                return (pageNo * pageSize + idx + 1);
            }
        }, {
            title: t('CreateTime'),
            dataIndex: 'CreateTime',
            width: 160,
            fixed: 'left',
        }, {
            title: t('Daily Grid Statistics (kWh)'),
            dataIndex: 'EDayToGrid',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Daily From Grid Statistics (kWh)'),
            dataIndex: 'EDayFromGrid',
            width: 220,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Daily Load Statistics (kWh)'),
            dataIndex: 'EDayLoad',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Daily EPS Statistics (kWh)'),
            dataIndex: 'EDayEPS',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Daily PV Statistics (kWh)'),
            dataIndex: 'EDayPV',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Daily To Battery Statistics (kWh)'),
            dataIndex: 'EDayToBattery',
            width: 220,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Daily From Battery Statistics (kWh)'),
            dataIndex: 'EDayFromBattery',
            width: 230,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Monthly Grid Statistics (kWh)'),
            dataIndex: 'EMonthToGrid',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Monthly From Grid Statistics (kWh)'),
            dataIndex: 'EMonthFromGrid',
            width: 220,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Monthly Load Statistics (kWh)'),
            dataIndex: 'EMonthLoad',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Monthly EPS Statistics (kWh)'),
            dataIndex: 'EMonthEPS',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Monthly PV Statistics (kWh)'),
            dataIndex: 'EMonthPV',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Monthly To Battery Statistics (kWh)'),
            dataIndex: 'EMonthToBattery',
            width: 220,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Monthly From Battery Statistics (kWh)'),
            dataIndex: 'EMonthFromBattery',
            width: 230,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Yearly Grid Statistics (kWh)'),
            dataIndex: 'EYearToGrid',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Yearly From Grid Statistics (kWh)'),
            dataIndex: 'EYearFromGrid',
            width: 220,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Yearly Load Statistics (kWh)'),
            dataIndex: 'EYearLoad',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Yearly EPS Statistics (kWh)'),
            dataIndex: 'EYearEPS',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Yearly PV Statistics (kWh)'),
            dataIndex: 'EYearPV',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Yearly To Battery Statistics (kWh)'),
            dataIndex: 'EYearToBattery',
            width: 220,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Yearly From Battery Statistics (kWh)'),
            dataIndex: 'EYearFromBattery',
            width: 230,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Total Grid Statistics (kWh)'),
            dataIndex: 'ETotalToGrid',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Total From Grid Statistics (kWh)'),
            dataIndex: 'ETotalFromGrid',
            width: 220,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Total Load Statistics (kWh)'),
            dataIndex: 'ETotalLoad',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Total EPS Statistics (kWh)'),
            dataIndex: 'ETotalEPS',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Total PV Statistics (kWh)'),
            dataIndex: 'ETotalPV',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Total To Battery Statistics (kWh)'),
            dataIndex: 'ETotalToBattery',
            width: 220,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Total From Battery Statistics (kWh)'),
            dataIndex: 'ETotalFromBattery',
            width: 230,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('PV1 Voltage (V)'),
            dataIndex: 'VPV1',
            width: 160,
            render: (v) => {
                return (v * 0.01).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('PV1 Current (A)'),
            dataIndex: 'IPV1',
            width: 160,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('PV1 Power (W)'),
            dataIndex: 'PPV1',
            width: 160,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('PV2 Voltage (V)'),
            dataIndex: 'VPV2',
            width: 160,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('PV2 Current (A)'),
            dataIndex: 'IPV2',
            width: 160,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('PV2 Power (W)'),
            dataIndex: 'PPV2',
            width: 160,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('PV3 Voltage (V)'),
            dataIndex: 'VPV3',
            width: 160,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('PV3 Current (A)'),
            dataIndex: 'IPV3',
            width: 160,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('PV3 Power (W)'),
            dataIndex: 'PPV3',
            width: 160,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('PV4 Voltage (V)'),
            dataIndex: 'VPV4',
            width: 160,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('PV4 Current (A)'),
            dataIndex: 'IPV4',
            width: 160,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('PV4 Power (W)'),
            dataIndex: 'PPV4',
            width: 160,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC1 Grid Voltage (V)'),
            dataIndex: 'VAC1Grid',
            width: 180,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC1 Grid Current (A)'),
            dataIndex: 'IAC1Grid',
            width: 180,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('AC1 Grid Power (W)'),
            dataIndex: 'PAC1Grid',
            width: 180,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC2 Grid Voltage (V)'),
            dataIndex: 'VAC2Grid',
            width: 180,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC2 Grid Current (A)'),
            dataIndex: 'IAC2Grid',
            width: 180,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('AC2 Grid Power (W)'),
            dataIndex: 'PAC2Grid',
            width: 180,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC3 Grid Voltage (V)'),
            dataIndex: 'VAC3Grid',
            width: 180,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC3 Grid Current (A)'),
            dataIndex: 'IAC3Grid',
            width: 180,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('AC3 Grid Power (W)'),
            dataIndex: 'PAC3Grid',
            width: 180,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC1 Inverter Voltage (V)'),
            dataIndex: 'VAC1Inverter',
            width: 200,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC1 Inverter Current (A)'),
            dataIndex: 'IAC1Inverter',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('AC2 Inverter Voltage (V)'),
            dataIndex: 'VAC2Inverter',
            width: 200,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC2 Inverter Current (A)'),
            dataIndex: 'IAC2Inverter',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('AC3 Inverter Voltage (V)'),
            dataIndex: 'VAC3Inverter',
            width: 200,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC3 Inverter Current (A)'),
            dataIndex: 'IAC3Inverter',
            width: 200,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('AC1 Load Voltage (V)'),
            dataIndex: 'VAC1Load',
            width: 180,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC1 Load Current (A)'),
            dataIndex: 'IAC1Load',
            width: 180,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('AC1 Load Power (W)'),
            dataIndex: 'PAC1Load',
            width: 180,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC2 Load Voltage (V)'),
            dataIndex: 'VAC2Load',
            width: 180,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC2 Load Current (A)'),
            dataIndex: 'IAC2Load',
            width: 180,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('AC2 Load Power (W)'),
            dataIndex: 'PAC2Load',
            width: 180,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC3 Load Voltage (V)'),
            dataIndex: 'VAC3Load',
            width: 180,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC3 Load Current (A)'),
            dataIndex: 'IAC3Load',
            width: 180,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('AC3 Load Power (W)'),
            dataIndex: 'PAC3Load',
            width: 180,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC1 EPS Power (W)'),
            dataIndex: 'PAC1EPS',
            width: 180,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC2 EPS Power (W)'),
            dataIndex: 'PAC2EPS',
            width: 180,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('AC3 EPS Power (W)'),
            dataIndex: 'PAC3EPS',
            width: 180,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('Battery Voltage (V)'),
            dataIndex: 'VBattery',
            width: 160,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('Battery Current (A)'),
            dataIndex: 'IBattery',
            width: 160,
            render: (v) => {
                if (v > 0x7fff) {
                    v -= 0x10000;
                }
                return (v * 0.01).toFixed(2);
            },
            transform: {
                signed: 0x7fff,
                multiplicative_inverse: 100
            }
        }, {
            title: t('Battery Power (W)'),
            dataIndex: 'PBattery',
            width: 160,
            render: (v) => {
                if (v > 0x7fffffff) {
                    v -= 0x100000000;
                }
                return (v * 0.1).toFixed(1);
            },
            transform: {
                signed: 0x7fffffff,
                multiplicative_inverse: 10
            }
        }, {
            title: t('Battery Temperature (℃)'),
            dataIndex: 'BatteryTemperature',
            width: 200,
            render: (v) => {
                if (v > 0x7fff) {
                    v -= 0x10000;
                }
                return (v * 0.1).toFixed(1);
            },
            transform: {
                signed: 0x7fff,
                multiplicative_inverse: 10
            }
        }, {
            title: t('SOC (%)'),
            dataIndex: 'SOC',
            width: 100,
        }, {
            title: t('SOH (%)'),
            dataIndex: 'SOH',
            width: 100,
        }, {
            title: t('Grid Frequency (Hz)'),
            dataIndex: 'GridHz',
            width: 160,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Power Factor'),
            dataIndex: 'PowerFactor',
            width: 160,
            render: (v) => {
                return (v * 0.001).toFixed(3);
            },
            transform: {
                multiplicative_inverse: 1000
            }
        }, {
            title: t('Leakage Current (mA)'),
            dataIndex: 'LeakageCurrent',
            width: 180,
             render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('BMS Charge Current Limit (A)'),
            dataIndex: 'BMSChargeCurrentLimit',
            width: 240,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('BMS Discharge Current Limit (A)'),
            dataIndex: 'BMSDischargeCurrentLimit',
            width: 250,
            render: (v) => {
                return (v * 0.01).toFixed(2);
            },
            transform: {
                multiplicative_inverse: 100
            }
        }, {
            title: t('Battery Cell Temperature Max (℃)'),
            dataIndex: 'BatteryCellTemperatureMax',
            width: 260,
            render: (v) => {
                if (v > 0x7fff) {
                    v -= 0x10000;
                }
                return (v * 0.1).toFixed(1);
            },
            transform: {
                signed: 0x7fff,
                multiplicative_inverse: 10
            }
        }, {
            title: t('Battery Cell Temperature Min (℃)'),
            dataIndex: 'BatteryCellTemperatureMin',
            width: 260,
            render: (v) => {
                if (v > 0x7fff) {
                    v -= 0x10000;
                }
                return (v * 0.1).toFixed(1);
            },
            transform: {
                signed: 0x7fff,
                multiplicative_inverse: 10
            }
        }, {
            title: t('BMS Charge And Discharge Control'),
            dataIndex: 'BMSChargeAndDischargeControl',
            width: 280,
        }, {
            title: t('Battery Forced Charge'),
            dataIndex: 'BatteryForcedCharge',
            width: 200,
        }, {
            title: t('Inverter BB Temperature (℃)'),
            dataIndex: 'InverterBBTemperature',
            width: 240,
            render: (v) => {
                if (v > 0x7fff) {
                    v -= 0x10000;
                }
                return (v * 0.1).toFixed(1);
            },
            transform: {
                signed: 0x7fff,
                multiplicative_inverse: 10
            }
        }, {
            title: t('Inverter Boost Temperature (℃)'),
            dataIndex: 'InverterBoostTemperature',
            width: 250,
            render: (v) => {
                if (v > 0x7fff) {
                    v -= 0x10000;
                }
                return (v * 0.1).toFixed(1);
            },
            transform: {
                signed: 0x7fff,
                multiplicative_inverse: 10
            }
        }, {
            title: t('Inverter Inner Temperature (℃)'),
            dataIndex: 'InverterInnerTemperature',
            width: 250,
            render: (v) => {
                if (v > 0x7fff) {
                    v -= 0x10000;
                }
                return (v * 0.1).toFixed(1);
            },
            transform: {
                signed: 0x7fff,
                multiplicative_inverse: 10
            }
        }, {
            title: t('Inverter L Temperature (℃)'),
            dataIndex: 'InverterLTemperature',
            width: 230,
            render: (v) => {
                if (v > 0x7fff) {
                    v -= 0x10000;
                }
                return (v * 0.1).toFixed(1);
            },
            transform: {
                signed: 0x7fff,
                multiplicative_inverse: 10
            }
        }, {
            title: t('Inverter R Temperature (℃)'),
            dataIndex: 'InverterRTemperature',
            width: 230,
            render: (v) => {
                if (v > 0x7fff) {
                    v -= 0x10000;
                }
                return (v * 0.1).toFixed(1);
            },
            transform: {
                signed: 0x7fff,
                multiplicative_inverse: 10
            }
        }, {
            title: t('Inverter Derated Power (W)'),
            dataIndex: 'InverterDeratedPower',
            width: 220,
            render: (v) => {
                return (v * 0.1).toFixed(1);
            },
            transform: {
                multiplicative_inverse: 10
            }
        }, {
            title: t('Inverter Load Reduction Cause'),
            dataIndex: 'InverterLoadReductionCause',
            width: 240,
        }, {
            title: t('Main DSP Status'),
            dataIndex: 'MainDSPStatus',
            width: 160,
        }, {
            title: t('Slave DSP Status'),
            dataIndex: 'SlaveDSPStatus',
            width: 160,
        }, {
            title: t('Status1'),
            dataIndex: 'Status1',
            width: 100,
        }, {
            title: t('Status2'),
            dataIndex: 'Status2',
            width: 100,
        }, {
            title: t('Error Code 1'),
            dataIndex: 'ErrorCode1',
            width: 120,
        }, {
            title: t('Error Code 2'),
            dataIndex: 'ErrorCode2',
            width: 120,
        }, {
            title: t('BMS Fault Code'),
            dataIndex: 'BMSFaultCode',
            width: 160,
        }, {
            title: t('BMS Warning Code'),
            dataIndex: 'BMSWarningCode',
            width: 170,
        },
    ];

    let strColumns = [];
    for (let i = 0; i < DefaultColumns.length; i++) {
        const c = DefaultColumns[i];
        if (c.dataIndex) {
            strColumns.push({
                title: c.title,
                dataIndex: c.dataIndex,
                transform: c.transform,
                width: c.width,
            });
        }
    }
    strColumns = encodeURIComponent(JSON.stringify(strColumns));

    return (
        <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
            <div style={{ flex: "none", padding: "10px" }}>
                <span>{t('Select Inverter')}</span>
                <Select
                    showSearch
                    placeholder={t("Enter Inverter Name")}
                    defaultActiveFirstOption={false}
                    showArrow={true}
                    filterOption={true}
                    onSelect={(value, option) => handleSelectSN(value, option)}
                    value={SN}
                    style={{ width: '200px', marginRight: '20px', marginLeft: '10px' }}
                >{inverterSelectOptions}</Select>
                <DatePicker
                    defaultValue={moment()}
                    value={moment(dataHistoryDate)}
                    onChange={(_, ds) => {
                        setDataHistoryDate(ds)
                        setAWeekAgoDate(moment(ds).subtract(7, 'days').format('YYYY-MM-DD'))
                    }}
                    allowClear={false}
                    locale={i18n.language === 'zh' ? zh_CN : en_US}
                />

                <Button type="primary" disabled={rows.length < 1 ? true : false} onClick={handleExport} style={{ float: 'right', marginRight: '10px', backgroundColor: '#0486be', color: '#fff' }}>{t('Export Data')}</Button>
            </div>
            <div style={{ flex: "auto", overflow: "hidden" }}>
                <Table
                    columns={DefaultColumns}
                    pagination={{
                        pageSizeOptions: [25, 50, 100],
                        current: pageNo + 1,
                        pageSize: pageSize,
                        total: rowTotal,
                        showSizeChanger: true,
                        showTotal: (total) => { return t('Total {{total}}', { total }) },
                        onShowSizeChange: (current, size) => {
                            setPageSize(size);
                        },
                        onChange: (page, pageSize) => {
                            setPageNo(page - 1);
                        }
                    }}
                    tableLayout="fixed"
                    bordered={true}
                    size="small"
                    loading={loading}
                    rowKey="ID"
                    dataSource={rows}
                    scroll={{ x: 'max-content', y: scrollY }}
                >
                </Table>
            </div>

            <a ref={refDownloader1} style={{ display: "none" }} href={config.apiUrl + "data-export/uhome-threephase/inverter/history/do?Token=" + http.token + "&SerialNumber=" + SN + "&SDate=" + dataHistoryDate + "&EDate=" + moment(dataHistoryDate).add(1, 'days').format('YYYY-MM-DD') + "&Columns=" + strColumns}></a>
        </div>
    )
}

export default DataHistoryUhomeThreePhase;